import React, { useEffect, useContext } from 'react'
import { AuthContext } from '../../../contexts/AuthContext'
import DesktopCE from './desktopComponents'
import MobileCE from './stepsMobile/index'
import { Loading } from '../../Simple'
import { useLocation } from 'react-router-dom'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import { LocalStorage } from '../../../services'
import moment from 'moment'

import './stylesCE.css'

export default function CentroEsportivo() {
  const location = useLocation()
  const { sttAuthCtx } = useContext(AuthContext)
  const { BuscarEmpresaEVerificarAcesso, loads, actionsCtxEmps } = useContext(EmpresasContext)

  async function buscarEmpresa(username) {
    if (username && username !== '') {
      if (!sttAuthCtx.isLogged) {
        LocalStorage.clear()
      }
      await actionsCtxEmps.ValidarDataDispositivo() // garante que validData esteja atualizado
      await BuscarEmpresaEVerificarAcesso(username)
    }
  }

  useEffect(() => {
    buscarEmpresa(location.pathname.split('/').pop()).then(() => {
      if (!sttAuthCtx.isLogged) {
        const url = location.pathname + location.search
        // Salva buffer com url e date : 'YYYY-MM-DD HH:mm:ss'
        const buffer = {
          url: url,
          date: moment().format('YYYY-MM-DD HH:mm:ss'),
        }
        LocalStorage.set('url-selecionada', buffer)
      }
    })
    // Usuario não logado? Salvar a url para redirecionar após o login!
  }, [])

  return (
    <>
      {loads.page ? (
        <div className='contain-loading'>
          <Loading text={'Carregando...'} color={!sttAuthCtx.isMobile ? 'white' : 'black'} />
        </div>
      ) : !sttAuthCtx.isMobile ? (
        <DesktopCE />
      ) : (
        <MobileCE />
      )}
    </>
  )
}
